// extracted by mini-css-extract-plugin
module.exports = {"main":"AuthContainer_main__3gAwx"};